// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1bFrR","productName":"Table_productName__2KlPI"};